"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSvg = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _mixins = require("../mixins");

var _context = require("../context");

var _utils = require("../utils");

var _env = require("../utils/env");

var _getUniqueID = require("../utils/getUniqueID");

var _core = require("@emotion/core");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: ", ";\n  ", "\n  flex-shrink: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mixins = (0, _utils.combineMixins)(_mixins.colorsMixin, _mixins.marginMixin, _mixins.alignSelfMixin);
var Svg = (0, _context.styledWithTheme)('svg')(_templateObject(), function (_ref) {
  var display = _ref.display;
  return display;
}, function (props) {
  return mixins(props);
});

var createBackgroundImageMixin = function createBackgroundImageMixin(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      paths = _ref2.paths;

  var mixin = function mixin(_ref3) {
    var theme = _ref3.theme,
        color = _ref3.color;
    return "url(\"data:image/svg+xml,".concat(encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' viewBox='0 0 ").concat(width, " ").concat(height, "' style='width: ").concat(width, "px; height: ").concat(height, "px;'>").concat(paths.map(function (path) {
      return "<path fill='".concat(theme.selectors.colorOrNull(color), "' fill-rule='evenodd' d='").concat(path, "'></path>");
    }).join(''), "</svg>")), "\")");
  };

  return mixin;
};

var createSvg = function createSvg(displayName, width, height) {
  var paths = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var Component = function Component(_ref4) {
    var _ref4$display = _ref4.display,
        display = _ref4$display === void 0 ? 'block' : _ref4$display,
        color = _ref4.color,
        margin = _ref4.margin,
        backgroundColor = _ref4.backgroundColor,
        title = _ref4.title,
        roleProp = _ref4.role,
        ariaHidden = _ref4['aria-hidden'],
        dataTestId = _ref4.dataTestId;

    var _useState = (0, _react.useState)((0, _getUniqueID.getUniqueID)()),
        _useState2 = (0, _slicedToArray2.default)(_useState, 1),
        count = _useState2[0];

    var hasTitle = !!title && !!title.trim().length;
    var isAccessible = hasTitle || roleProp === 'presentation' || ariaHidden;

    if ((0, _env.envIsDevelopment)() && !isAccessible) {
      console.warn("For accessibility, icons should either have a 'title', use 'role=\"presentation\"', or use 'aria-hidden={true}'. Check the icon with data-test-flagged=\"icon-accessibility\".");
    }

    var dataTestProps = (0, _utils.buildDataTestProps)({
      dataTestComponent: "Stencil".concat(displayName),
      dataTestId: dataTestId
    });
    var dataProps = isAccessible ? dataTestProps : (0, _objectSpread2.default)({}, dataTestProps, {
      'data-test-flagged': 'icon-accessibility'
    });
    var svgTitleId = title && hasTitle ? "icon-".concat(count) : '';
    var labelledby = hasTitle ? {
      'aria-labelledby': svgTitleId
    } : {};
    var role = ariaHidden ? 'presentation' : roleProp;
    return (0, _core.jsx)(Svg, (0, _extends2.default)({
      color: color,
      display: display,
      xmlns: "http://www.w3.org/2000/svg",
      className: "stencilSvgIcon",
      width: width,
      height: height,
      margin: margin,
      role: role,
      "aria-hidden": ariaHidden,
      focusable: "false",
      backgroundColor: backgroundColor,
      style: {
        width: width,
        height: height
      },
      viewBox: "0 0 ".concat(width, " ").concat(height)
    }, labelledby, dataProps, params), hasTitle && (0, _core.jsx)("title", {
      id: svgTitleId
    }, title), paths.map(function (d, i) {
      return (0, _core.jsx)("path", {
        key: "path".concat(i),
        fillRule: "evenodd",
        fill: "currentColor",
        d: d
      });
    }));
  };

  Component.displayName = displayName;
  Component.defaultProps = {
    display: 'block',
    role: 'img'
  };
  Component.backgroundImage = createBackgroundImageMixin({
    width: width,
    height: height,
    paths: paths
  });
  var ComponentWithDocs = (0, _stencilReactDesc.describe)(Component).description("".concat(displayName, " icon."));
  ComponentWithDocs.propTypes = (0, _objectSpread2.default)({}, mixins.describedPropTypes, {
    display: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'display' property for the element."),
    title: _stencilReactDesc.PropTypes.string.description('Used as alt text for the icon for screen readers. Leave blank if the icon is purely presentational.'),
    dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
  });
  return Component;
};

exports.createSvg = createSvg;